// src/redux/inventorycategorySlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_inventorycategory,
  add_inventorycategory,
  update_inventorycategory,
  delete_inventorycategory,
  get_inventorycategory_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  inventorycategory: [],
  inventorycategorylist:[],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description: "",
  },
};

// Async Thunks for API Calls
export const fetchinventorycategoryList = createAsyncThunk(
    'inventorycategory/fetchinventorycategorylist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_inventorycategory_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchinventorycategory = createAsyncThunk(
  "inventorycategory/fetchinventorycategory",
  async ({ page, page_size,school_id,search, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_inventorycategory(page, page_size,school_id,search,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createinventorycategory = createAsyncThunk(
  "inventorycategory/createinventorycategory",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_inventorycategory(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateinventorycategory = createAsyncThunk(
  "inventorycategory/updateinventorycategory",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_inventorycategory(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteinventorycategory = createAsyncThunk(
  "inventorycategory/deleteinventorycategory",
  async ({ ids,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_inventorycategory({ ids }, school_id,token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// inventorycategory Slice
const inventorycategorySlice = createSlice({
  name: 'inventorycategorys',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,description} = action.payload;
      state.formData = { id, name,description};
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description: "",
      };
    },
    setinventorycategory(state, action) {
      state.inventorycategory = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
 
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchinventorycategoryList.fulfilled, (state, action) => {
        state.inventorycategorylist = action.payload.data;
      })
      .addCase(fetchinventorycategoryList.rejected, (state, action) => {
        state.inventorycategorylist = [];
      })
     
       // Fetch inventorycategory
       .addCase(fetchinventorycategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchinventorycategory.fulfilled, (state, action) => {
        state.loading = false;
        state.inventorycategory = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchinventorycategory.rejected, (state, action) => {
        state.loading = false;
        state.inventorycategory = [];
        state.error = action.payload;
      })

      // Add inventorycategory
      .addCase(createinventorycategory.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createinventorycategory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createinventorycategory.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update inventorycategory
      .addCase(updateinventorycategory.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateinventorycategory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateinventorycategory.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete inventorycategory
      .addCase(deleteinventorycategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteinventorycategory.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteinventorycategory.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setinventorycategory,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize } = inventorycategorySlice.actions;
export default inventorycategorySlice.reducer;
